/** @format */

import React, { FunctionComponent, useState, useRef, useEffect } from 'react'
import AlarmReciver from 'src/components/AlarmReciver'
import AlarmCallBack from 'src/components/AlarmCallBack'
import CustomMonitorDimens from './customMonitorDimens'
import { Drawer, Form, FormItem, Input, Select, Option, _$ } from '@king-design/react'
import 'src/static/styles/alarmform.styl'
import { useAsyncFn } from 'react-use'
import { request } from 'src/utils'
import styled from 'styled-components'
import { targetPeriod, targetMethod, CountData, MethodOp } from 'src/config'

interface contactProps {
  contactFlag: number
  contactId: number
  contactName: string | number
  contactWay: number
  info: any
}
export interface itemProps {
  contactList?: contactProps[]
  callbackURLs?: string[]
  cycles?: number
  dimension?: string
  enabled?: number
  method?: string
  metricName?: string
  nameSpace?: string
  op?: string
  period?: number
  policyId?: number
  policyName?: string
  region?: string
  state?: number
  thresHold?: number | ''
}

interface alarmFormProps {
  defaultValue?: itemProps // 默认值
  disabled?: boolean
  visible?: boolean
  cancel?: () => void
  region?: string
  className?: string
  onOk: (params?: itemProps) => void
}

const CustomAlarm: FunctionComponent<alarmFormProps> = ({
  defaultValue = null,
  disabled = false,
  visible,
  cancel,
  region,
  className,
  onOk
}) => {
  const form = useRef<any>()
  const userRef = useRef<any>()
  const useCallback = useRef<any>()
  const dimens = useRef<any>()
  const [model, setFormParams] = useState<itemProps>({
    period: 1,
    method: 'max',
    cycles: 1,
    op: '>='
  })
  // 获取命名空间
  const [nameSpace, getNameSpaceList] = useAsyncFn(async region => {
    if (!region) return []
    const resData = await request('/cm/metrics/DescribeNameSpaces', {
      method: 'get',
      data: {
        region: region
      }
    })
    return resData?.data
  })

  // 获取指标名称列表
  const [metricData, getMetricNames] = useAsyncFn(async (region, spaceValue) => {
    if (!region) return []
    const nameData = await request('/cm/metrics/DescribeMetricsUnique', {
      method: 'get',
      data: {
        region: region,
        nameSpace: spaceValue
      }
    })
    return nameData?.data?.metricUniqList || []
  })
  // 获取维度接口
  const [dimensions, getDimensions] = useAsyncFn(async (region, spaceValue, metricName) => {
    if (!metricName || !spaceValue || !region) return []
    const demensData = await request('/cm/metrics/DescribeDimensions', {
      method: 'get',
      data: {
        region: region,
        nameSpace: spaceValue,
        metricName: metricName
      }
    })
    return demensData?.data?.dimensionList
  })
  // 表单规则验证
  const validataValues = async () => {
    const valresult = await form.current.validate()
    if (!valresult) {
      return
    }
    const params = await generateParams()
    onOk && params && onOk(params)
  }
  // 生成表单数据
  const generateParams = async () => {
    const dimensions = dimens.current && dimens.current.getDimensData()
    const users = userRef.current && userRef.current.getRecivers()
    const url = useCallback.current && (await useCallback.current.getUrl())
    if (!url || !users) return false
    const filterDimensions = []
    let isDimsNull = false
    Array.isArray(dimensions) &&
      dimensions.forEach(item => {
        if (!item.key && !item.value) return
        if (item.key && !item.value) isDimsNull = true
        filterDimensions.push(item.key + '=' + item.value)
      })
    const params = {
      ...model,
      region: region,
      dimension: filterDimensions.join(','),
      enabled: 0,
      contactList: users,
      callbackURLs: url,
      thresHold: Number(model?.thresHold),
      isDimsNull: isDimsNull // 维度值是否为空
    }
    // 创建自定义警报
    return params
  }

  useEffect(() => {
    if (region) {
      if (defaultValue && !defaultValue?.nameSpace) {
        getNameSpaceList(region)
        setFormParams({
          period: 1,
          method: 'max',
          cycles: 1,
          op: '>='
        })
        return
      }
      if (!defaultValue) return
      const { nameSpace, metricName } = defaultValue
      const regionKey = region || defaultValue?.region
      Promise.all([
        getNameSpaceList(regionKey),
        getMetricNames(regionKey, nameSpace),
        getDimensions(regionKey, nameSpace, metricName)
      ]).then(() => {
        defaultValue &&
          setFormParams({
            period: 1,
            method: 'max',
            cycles: 1,
            op: '>=',
            ...defaultValue
          })
      })
    }
  }, [defaultValue])
  return (
    <>
      <Drawer
        title={_$('创建/修改警报')}
        width={620}
        value={visible}
        mode="destroy"
        ok={() => validataValues()}
        className="custom-alarm-drawer"
        onClose={() => {
          cancel && cancel()
          setFormParams(undefined)
        }}
      >
        {visible ? (
          <div className={className}>
            <Form layout="vertical" starOnRequired ref={i => (form.current = i)}>
              <FormItem
                label={_$('警报名称')}
                rules={{ required: true, userName: true }}
                value={model?.policyName}
              >
                <Input
                  style={{ display: 'inline-block' }}
                  value={model?.policyName || ''}
                  onChangeValue={value => setFormParams(state => ({ ...state, policyName: value }))}
                />
              </FormItem>
              <FormItem label={_$('命名空间')} rules={{ required: true }} value={model?.nameSpace}>
                <Select
                  container={dom => dom.parentElement}
                  disabled={disabled && defaultValue?.nameSpace ? disabled : false}
                  value={model?.nameSpace}
                  // onChangeValue={(value) => {
                  //   setFormParams(state => ({ ...state, nameSpace: value }))
                  // }}
                  onChangeValue={value => {
                    setFormParams(state => ({ ...state, nameSpace: value, metricName: '' }))
                    const regionKey = region || defaultValue?.region
                    getMetricNames(regionKey, value)
                  }}
                >
                  {nameSpace?.value?.['nameSpaceList'] &&
                    nameSpace?.value?.['nameSpaceList'].map(item => (
                      <Option value={item.nameSpace} key={item.nameSpace}>
                        {_$(item.nameSpace)}
                      </Option>
                    ))}
                </Select>
              </FormItem>
              {model?.nameSpace && metricData?.value ? (
                <FormItem
                  label={_$('指标名称')}
                  rules={{ required: true }}
                  value={model?.metricName}
                >
                  <Select
                    container={dom => dom.parentElement}
                    disabled={disabled && defaultValue?.metricName ? disabled : false}
                    filterable
                    value={model?.metricName}
                    // onChangeValue={(value) => {
                    //   setFormParams(state => ({ ...state, metricName: value }))
                    // }}
                    onChangeValue={value => {
                      setFormParams(state => ({ ...state, metricName: value }))
                      const regionKey = region || defaultValue?.region
                      getDimensions(regionKey, model?.nameSpace, value)
                    }}
                  >
                    {Array.isArray(metricData?.value) &&
                      metricData?.value.map((item, index) => (
                        <Option value={item?.metricName} key={item?.metricName + index}>
                          {_$(item?.metricName)}
                        </Option>
                      ))}
                  </Select>
                </FormItem>
              ) : null}
              {/* nameSpace没有时不显示 */}
              {model?.nameSpace && model?.metricName ? (
                <FormItem label={_$('维度')}>
                  <CustomMonitorDimens
                    dimensionList={dimensions}
                    ref={dimens}
                    defaultDimensData={defaultValue?.dimension}
                  />
                </FormItem>
              ) : null}
              <FormItem label={_$('阈值规则')} className="custom-alarm-rule">
                <Select
                  container={dom => dom.parentElement}
                  value={model?.period}
                  onChangeValue={value => setFormParams(state => ({ ...state, period: value }))}
                  placeholder={_$('统计周期')}
                >
                  {targetPeriod.map(item => (
                    <Option key={item.value} value={item.value}>
                      {_$(item.label)}
                    </Option>
                  ))}
                </Select>
                <Select
                  container={dom => dom.parentElement}
                  value={model?.method}
                  onChangeValue={value => setFormParams(state => ({ ...state, method: value }))}
                  placeholder={_$('统计方法')}
                >
                  {targetMethod.map(item => (
                    <Option key={item.value} value={item.value}>
                      {_$(item.label)}
                    </Option>
                  ))}
                </Select>
                <Select
                  container={dom => dom.parentElement}
                  value={model?.cycles}
                  onChangeValue={value => setFormParams(state => ({ ...state, cycles: value }))}
                  placeholder={_$('持续次数')}
                >
                  {CountData.map(item => (
                    <Option value={item} key={item}>
                      {_$('连续{n}次', { n: item })}
                    </Option>
                  ))}
                </Select>
                <Select
                  container={dom => dom.parentElement}
                  onChangeValue={value => setFormParams(state => ({ ...state, op: value }))}
                  placeholder={_$('大小')}
                  value={model?.op}
                >
                  {MethodOp.map(item => (
                    <Option value={item.key} key={item.key}>
                      {_$(item.value)}
                    </Option>
                  ))}
                </Select>
                <FormItem
                  hideLabel
                  label={_$('阈值')}
                  value={model?.thresHold}
                  rules={{ required: true, isNumber: true }}
                >
                  <Input
                    placeholder={_$('请输入阈值')}
                    className="alarm-input"
                    value={model?.thresHold || model?.thresHold === 0 ? model?.thresHold : ''}
                    onChangeValue={value => {
                      setFormParams(state => ({ ...state, thresHold: value }))
                    }}
                  />
                </FormItem>
              </FormItem>
              <FormItem label={_$('告警接收对象')}>
                <AlarmReciver ref={userRef} defaultValue={model?.contactList} />
              </FormItem>
              <FormItem label={_$('告警回调')}>
                <AlarmCallBack ref={useCallback} defaultValue={model?.callbackURLs} />
              </FormItem>
            </Form>
          </div>
        ) : null}
      </Drawer>
    </>
  )
}
export default styled(CustomAlarm)`
  .custom-alarm-rule .k-select {
    margin-bottom: 8px;
  }
`
